import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FileOpenRounded, VerifiedRounded } from "@mui/icons-material";
import { Form, Switch, notification, Drawer, Typography, Space, Tag, Row, Divider, Image, Badge } from 'antd';
import { setUserFields } from "../../../Api/userApi";
import { prefixObjectKeys } from "../../../utils/tools";
import Files from "../../Files/Files";
import { GoogleCloudStorageBucketUrl } from "../../../Configs/Domain";
import Logo from "../../../Components/Graphics/Logo";

const PageDefaultsForm = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const userDefaults = useSelector((state) => state.user?.data?.defaultFields?.pages);
  const [showFiles, setShowFiles] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState(userDefaults?.logo_url ?? '');
  const [isChanged, setIsChanged] = useState(false);

  const logoUri = selectedLogo !== '' && `${GoogleCloudStorageBucketUrl}${selectedLogo}`;

  const handleValuesChange = async (changedValues, allValues) => {
    const initial = {
      is_public: userDefaults?.is_public,
      logo_url: userDefaults?.logo_url,
    };
    const isFormChanged = Object.keys(initial).some(key => allValues[key] !== initial[key]);
    setIsChanged(isFormChanged);

    if (isFormChanged) {
      await onFormFinish(allValues);
    }
  };

  const handleFilepathSelect = async (selectedFilePath) => {
    try {
      const file = selectedFilePath[0];
      setSelectedLogo(file);
      setShowFiles(false);
      form.setFieldsValue({ logo_url: file });
      await onFormFinish(form.getFieldsValue());  // Trigger autosave
    } catch (e) {
      notification.error({
        message: 'Error selecting file',
        description: e.message,
      });
    }
  };

  const onFormFinish = async (values) => {
    try {
      const newFormData = prefixObjectKeys(values, 'defaultFields.pages');
      await dispatch(setUserFields({ changedFields: newFormData })).then((resp) => {
        console.log(resp);
      });
      setIsChanged(false);
      notification.success({ message: 'Pages Default Settings Updated Successfully' });
    } catch (error) {
      notification.error({
        message: 'Failed to Update Settings',
        description: error.message,
      });
    }
  };

  return (
    <Form form={form} layout="vertical" onFinish={onFormFinish} onValuesChange={handleValuesChange}>
        <Typography.Title level={5}>
          IQ Branding
        </Typography.Title>
        <Typography.Text>Add your Logo to your IQ Pages</Typography.Text>
        <Divider/>
        <Form.Item name="logo_url">
          <Space direction='horizontal' onClick={() => setShowFiles(true)}>
            {logoUri && <Badge dot={true}><Image src={logoUri} height={48} width={'auto'} /></Badge>}
            {!logoUri && <Tag color='red-inverse'>No File Selected</Tag>}
          </Space>
        </Form.Item>
        <Form.Item name="is_public" valuePropName="checked">
          <Switch
            checkedChildren="Public IQ"
            unCheckedChildren="Private IQ"
            defaultChecked={userDefaults?.is_public}
          />
        </Form.Item>
      <Drawer
        open={showFiles}
        onClose={() => setShowFiles(false)}
        width='100%'
        mask={false}
        bodyStyle={{ padding: 0, margin: 0 }}
        title="Viewing Files as Popup"
      >
        <Files
          onSelect={handleFilepathSelect}
          fullscreen={false}
          maxSelect={1}
          whitelistExtensions={['png', 'jpg', 'jpeg']}
        />
      </Drawer>
    </Form>
  );
};

export default PageDefaultsForm;
